<template>
    <Button
        :type="isNotEmpty ? 'primary' : 'default'"
        :ghost="isNotEmpty"
        @click="onClick"
    >
        <span class="adv-text">筛选</span>
        <common-icon
            class="adv-icon"
            type="ios-funnel"
            :size="14"
            :color="isNotEmpty ? $theme.primaryColor : 'black'"
        ></common-icon>
        <smart-modal
            v-model="show"
            :width="800"
            :height="600"
            :maskClosable="false"
            :showHeader="false"
            :modalBeforeEnter="fetch"
            :modalBeforeBtnClick="btnHandlers"
            :buttons="buttons"
            @close-by-confirm="onConfirm"
        >
            <Form
                class="adv-form"
                ref="pInfo"
                :model="pInfo"
                :rules="rules"
                :label-width="200"
                label-position="top"
            >
                
                <FormItem label="水电余额流水类型" prop="tradeType">
                    <check-tag-group
                        v-model="pInfo.tradeType"
                        color="primary"
                        multiple
                    >
                        <check-tag
                            v-for="item in this.dict.tradeType.toList()"
                            class="adv-check-tag"
                            :name="item.id"
                            :key="item.id"
                            >{{ item.text }}</check-tag
                        >
                    </check-tag-group>
                </FormItem>

                <!-- <FormItem
                    v-if="amountLabel.length"
                    :label="amountLabel"
                    prop="weflowAmountZfType"
                >
                    <check-tag-group
                        v-model="pInfo.weflowAmountZfType"
                        color="primary"
                        multiple
                    >
                        <check-tag
                            v-for="item in this.dict.weflowAmountZfType.toList()"
                            class="adv-check-tag"
                            :name="item.id"
                            :key="item.id"
                            >{{ item.text }}</check-tag
                        >
                    </check-tag-group>
                </FormItem> -->

                <!-- <FormItem label="金额">
                   <input-number v-model="pInfo.startAmount" style="width: 80px" :maxlength="20" placeholder="起金额cs">

                   </input-number>    
                   <input-number v-model="pInfo.endAmount" style="width: 80px" :maxlength="20" placeholder="止金额">
                        
                   </input-number>     
                    <span>元</span>
                </FormItem> -->

            <FormItem label="金额">

            <Row :gutter="10">
            <Col span="3">
                
                    <input-number v-model="pInfo.startAmount" style="width: 80px" :maxlength="20" placeholder="起">

                   </input-number>                       
                
            </Col>
            <Col span="3">                
                    <input-number v-model="pInfo.endAmount" style="width: 80px" :maxlength="20" placeholder="止">
                        
                   </input-number>             
            </Col>
            </Row>
            </FormItem>
                                                
                <FormItem label="时间" prop="remark">
                    <div>
                        <div class="flex">
                            <check-tag-group
                                v-model="includeTime"
                                color="primary"
                                multiple
                                @on-change="onTimeChange"
                                ><check-tag
                                    class="adv-check-tag"
                                    name="createTime"
                                    >{{ timeLabel }}</check-tag
                                >
                            </check-tag-group>
                            <filter-date-range
                                v-show="includeTime.length"
                                :startDate.sync="pInfo.startDate"
                                :endDate.sync="pInfo.endDate"
                            ></filter-date-range>
                        </div>
                    </div>
                </FormItem>
            </Form>
        </smart-modal>
    </Button>
</template>

<script>
import FilterDateRange from '_vc/filter/filter-date-range'

export default {
    name: 'rechargeWeFlowAdvSearch',
    components: {
        FilterDateRange,
    },
    props: {
        value: {
            type: Object,
            default: () => ({}),
        },
        name: {
            type: String,
            default: '',
        },
    },
    data() {
        return {
            show: false,
            buttons: [
                { type: 'default', text: '重置', name: 'reset' },
                { type: 'primary', text: '确定', name: 'confirm' },
            ],
            btnHandlers: {
                reset: this.onReset,
            },
            dict: {
                weflowAmountZfType: this.$dict.NULL,
                tradeType: this.$dict.NULL,                
            },
            pInfo: {
                weflowAmountZfType:[],
                tradeType: [],            
                startDate: '',
                endDate: '',
                startAmount: "",
                endAmount: "",
            },            
            includeTime: [],
        }
    },
    computed: {
        rules() {},
        isNotEmpty() {
            return Object.values(this.value).some((v) => v.length)
        },
        
        
        //
        amountLabel() {            
            return '金额'
        },
        // 日期筛选标题
        timeLabel() {        
            return '流水时间'
        },
    },
    methods: {
        fetch(next) {
            return Promise.all([
                this.$dict.get([
                    'weflow_amount_zf_type',
                    'trade_type',
                ]),                
            ])
                .then((args) => {
                    var [group] = args

                    Object.assign(this.dict, group)                    
                    // 重新赋值
                    var val = this.value || {}
                    Object.keys(this.pInfo).forEach((k) => {
                        if (typeof val[k] !== 'undefined') {
                            this.pInfo[k] = val[k]
                        }
                    })
                    // 日期
                    this.includeTime =
                        this.pInfo.startDate || this.pInfo.endDate
                            ? ['time']
                            : []
                })
                .then(() => next())
        },
        onClick() {
            this.show = true
        },
        onConfirm() {
            this.$emit('input', this.pInfo)
            this.$emit('confirm', this.pInfo, this.getSelectedOptions())
        },
        onTimeChange(val) {
            if (val.length <= 0) {
                this.pInfo.startDate = ''
                this.pInfo.endDate = ''
            }
        },
        // 重置
        onReset(next, options) {
            options.closeModal = false
            Object.keys(this.pInfo).forEach((k) => {
                this.pInfo[k] = typeof this.pInfo[k] === 'object' ? [] : ''
            })
            next()
        },
        getSelectedOptions() {
            var options = []

            Object.keys(this.pInfo).forEach((k) => {
                var v = this.pInfo[k]

                // 日期区间
                // prettier-ignore
                if (k === 'startDate') {
                    var t1 = k,
                        t2 = 'endDate',
                        v1 = this.pInfo[t1],
                        v2 = this.pInfo[t2],
                        title = this.timeLabel

                    if(!v1 && !v2){
                        return
                    }

                    options.push({
                        id: `${v1}-${v2}`,
                        key: `${t1}-${t2}`,
                        text: `${v || '不限'}至${this.pInfo[t2] || '不限'}`,
                        label: `${title}`
                    })
                } else if (v) {
                    // prettier-ignore
                    switch (k) {                                                                                            
                        case 'weflowAmountZfType':
                            v.forEach(p => options.push({
                                id: p,
                                text: this.dict.weflowAmountZfType.val(p),
                                key: k,
                                label: '金额'
                            }))
                            break
                        case 'tradeType':
                            v.forEach(p => options.push({
                                id: p,
                                text: this.dict.tradeType.val(p),
                                key: k,
                                label: '水电余额流水类型'
                            }))
                            break                    
                    }
                }
            })

            return options
        },
    },
}
</script>

<style lang="less" scoped>
.adv {
    &-form {
        padding: 0 10px;
    }
    &-text {
        margin-right: 10px;
    }
    &-icon {
        vertical-align: -1px;
    }
    &-check-tag {
        padding: 2px 12px;
        height: auto;
    }
}
</style>
